import {
  useMutation,
  UseMutationOptions,
  useQuery,
  UseQueryOptions,
} from "@tanstack/react-query";

import { CoreApi } from "../helpers/Http";

/**
 * Delete File
 *
 * @param payload
 * @param options
 * @returns
 */

// DELETE /api/v1/clients/{id}/files
export const useDeleteClientFile = (options?: UseMutationOptions) => {
  const mutationFn = async (body: any) =>
    await CoreApi.delete(`clients/${body.id}/${body.baseurl}`);
  return useMutation({ mutationFn });
};

/**
 * Change File Status
 *
 * @param payload
 * @param options
 * @returns
 */

export const useChangeFileStatus = (options?: UseMutationOptions) => {
  const mutationFn = async (body: {
    id: any;
    reqBody: {
      isSensitive: boolean;
    };
  }) =>
    await CoreApi.put(`clients/${body.id}/files/change-status`, body.reqBody);

  return useMutation({ mutationFn });
};

/**
 * Update Client File Upload
 *
 * @param payload
 * @param options
 * @returns
 */

export const useUpdateClientFileUpload = (
	options?: UseMutationOptions
) => {
	const mutationFn = async ({ id, body }: any) =>
		await CoreApi.post(`clients/${id}/files`, body);

	return useMutation({ mutationFn });
};

/**
 * Update Download Status
 *
 * @param payload
 * @param options
 * @returns
 */

export const useUpdateDownloadStatus = (options?: UseMutationOptions) => {
  const mutationFn = async (body: {
    id: string;
    reqBody: {
      uploadType: any;
      files: any;
    };
  }) =>
    await CoreApi.put(`clients/${body.id}/files/download-status`, body.reqBody);

  return useMutation({ mutationFn });
};

/**
 * Update Client File Chunk Upload
 *
 * @param payload
 * @param options
 * @returns
 */

export const useUpdateClientFileChunksUpload = (
	options?: UseMutationOptions
) => {
	const mutationFn = async ({ batchNumber, body }: any) =>
		await CoreApi.post(`files/chunks/${batchNumber}/chunk-upload`, body);

	return useMutation({ mutationFn });
};


/**
 * Update Client File Upload Chunk batch
 *
 * @param payload
 * @param options
 * @returns
 */

export const useUpdateClientFileChunksBatchUpload = (
	options?: UseMutationOptions
) => {
	const mutationFn = async ({ id, body }: any) =>
		await CoreApi.post(`files/clients/${id}/chunks/file-upload`, body);

	return useMutation({ mutationFn });
};

/**
 * Update Client Research File Upload Chunk batch
 *
 * @param payload
 * @param options
 * @returns
 */

export const useUpdateClientResearchFileChunksBatchUpload = (
	options?: UseMutationOptions
) => {
	const mutationFn = async ({ id, body }: any) =>
		await CoreApi.post(`files/clients/${id}/chunks/experiments-upload`, body);

	return useMutation({ mutationFn });
};

